import React from 'react';
import styles from '../styles.module.css';
import ServiceIncludes from './ServiceIncludes';
import ServiceProcessSteps from './ServiceProcessSteps';
import Comments from '@/components/pages/blog/SingleBlogContent/Comments';
import { shopServiceType } from '@/commonTypes';
import ShopServiceQA from './ShopServiceQA';
import ShopCard from '@/components/pages/shops/ShopsContent/ShopCard';
import OtherShopServices from './OtherShopServices/ndex';

export default function ServiceShopBody({ data }: { data?: shopServiceType }) {
  return (
    <div className={`${styles.heroGrid}`}>
      <div>
        <ServiceIncludes />
        <ServiceProcessSteps />
        <Comments
          target="service"
          targetId={data?.id}
          showAllRates={false}
          showRateTitle={true}
          titleClass={`${styles.heading} ${styles.noMargin}`}
          className={`${styles.serviceHead}`}
          commentContentStyle={`${styles.commentContentStyle}`}
        />
        <ShopServiceQA className={`mb-0px`} />
      </div>
      <div className={`${styles.sideGrid}`}>
        <ShopCard item={data?.shop} showDetails={true} />
        <OtherShopServices shop={data?.shop} />
      </div>
    </div>
  );
}
